import type { EventSchema } from '~/types/schema';

const _processEventContent = (event: EventSchema) => {
  if (!event.content) {
    event.content = '';
    return;
  }

  const regex = /Programme(.)*?<\/h4>/i;
  const match = event.content.match(regex);
  if (!match) return null;

  const indexAfterMatch = match.index + match[0].length;
  const remainingText = event.content.slice(indexAfterMatch);

  // Remove HTML tags
  const cleanedText = remainingText.replace(/<[^>]+>/g, '');
  event.content = cleanedText;
};

const _getEventForSponsorInfo = (event: EventSchema) => {
  const logo = event?.medias?.length ? event.medias[0] : null;
  const { id, title, domains, address, dateEnd, dateStart, slug } = event;
  return {
    logo,
    id,
    title,
    domains,
    address,
    dateEnd,
    dateStart,
    slug,
    // medias,
  };
};

const _getSponsorInfoForEvent = (sponsorInfo: SponsorInfoSchema) => {
  let logo: MediaSchema;
  let banner: MediaSchema;
  if (sponsorInfo?.medias?.length) {
    logo = sponsorInfo.medias[0];
    banner = sponsorInfo.medias.length >= 2 ? sponsorInfo.medias[1] : null;
  }
  const { domains } = sponsorInfo;
  return {
    id: sponsorInfo.id,
    title: sponsorInfo.title,
    logo,
    banner,
    domains,
    campusArray: sponsorInfo.campusArray || [],
    slug: sponsorInfo.slug,
  };
};

export const processEventsAndSponsorInfos = (
  events: EventSchema[],
  sponsorInfos: SponsorInfoSchema[]
) => {
  const mSponsors = new Map<string, any>();
  const mEvents = new Map<string, EventSchema>();
  const mSponsorInfos = new Map<string, SponsorInfoSchema>();
  // retrieve sponsors in sponsorInfos
  sponsorInfos.forEach((sponsorInfo) => {
    const { id: sponsorInfoId, sponsorsArray } = sponsorInfo;
    sponsorInfo.logo =
      sponsorInfo.medias?.length && sponsorInfo.medias.length >= 1
        ? sponsorInfo.medias[0]
        : null;
    sponsorInfo.banner =
      sponsorInfo.medias?.length && sponsorInfo.medias.length >= 2
        ? sponsorInfo.medias[1]
        : null;
    mSponsorInfos.set(sponsorInfoId, sponsorInfo);
    sponsorsArray?.length &&
      sponsorsArray.forEach((sp) => {
        let sponsor: any;
        if (!mSponsors.has(sp.id)) {
          sponsor = {
            ...sp,
            sponsorInfoIds: [],
            eventIds: [],
          };
          mSponsors.set(sponsor.id, sponsor);
        } else {
          sponsor = mSponsors.get(sp.id);
        }
        sponsor.sponsorInfoIds.push(sponsorInfoId);
      });
  });
  // retrieve sponsors in events, add events in sponsorInfos, process content
  events.forEach((event) => {
    const { id: eventId, sponsorsArray } = event;
    _processEventContent(event);
    event.logo =
      event.medias?.length && event.medias.length >= 1 ? event.medias[0] : null;
    mEvents.set(eventId, event);
    sponsorsArray?.length &&
      sponsorsArray.forEach((sp) => {
        let sponsor: any;
        if (!mSponsors.has(sp.id)) {
          sponsor = {
            ...sp,
            sponsorInfoIds: [],
            eventIds: [],
          };
          mSponsors.set(sponsor.id, sponsor);
        } else {
          sponsor = mSponsors.get(sp.id);
        }
        sponsor.eventIds.push(eventId);
        sponsor.sponsorInfoIds.forEach((sponsorInfoId) => {
          if (mSponsorInfos.has(sponsorInfoId)) {
            const sponsorInfo = mSponsorInfos.get(sponsorInfoId);
            if (!sponsorInfo.events) sponsorInfo.events = [];
            sponsorInfo.events.push(_getEventForSponsorInfo(event));
          }
        });
      });
  });

  sponsorInfos.forEach((sponsorInfo) => {
    const { sponsorsArray } = sponsorInfo;
    sponsorsArray?.length &&
      sponsorsArray.forEach((sp) => {
        const sponsor = mSponsors.get(sp.id);
        sponsor.eventIds.forEach((eventId) => {
          if (mEvents.has(eventId)) {
            const event = mEvents.get(eventId);
            if (!event.sponsorInfos) event.sponsorInfos = [];
            if (!event.domains) event.domains = [];
            const sponsorInfoResumed = _getSponsorInfoForEvent(sponsorInfo);
            event.domains = [...event.domains, ...sponsorInfoResumed.domains];
            if (!event.banner && sponsorInfoResumed.banner)
              event.banner = { ...sponsorInfoResumed.banner };
            event.sponsorInfos.push(sponsorInfoResumed);
          }
        });
      });
  });
};
